module.exports = __webpack_public_path__ + "img/placeholder.45865260.jpg";